import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginPopupService {
  isOpen$ = new BehaviorSubject<Tab>(null);
  openTab$ = new BehaviorSubject<Tab>(null);

  tab: Tab = 'login';

  constructor() {}

  open(tab: Tab = 'login') {
    this.isOpen$.next(tab);
  }

  close() {
    this.isOpen$.next(null);
  }

  openTab(tab: Tab) {
    this.openTab$.next(tab);
  }
}

type Tab = 'login' | 'register' | 'new-user-login' | 'recover-password' | null;
